"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateControlContextFromParentInfo = (parentInfo) => {
    switch (parentInfo.context.type) {
        case 'isPage':
            return { type: 'pageControl', pageId: parentInfo.context.id };
        case 'pageTopNavControl':
        case 'pageControl':
            return parentInfo.context;
        case 'sideMenu':
        case 'pageSideMenuControl':
            return { type: 'pageSideMenuControl' };
        case 'isBottomMenuSheet':
        case 'pageBottomMenuSheetControl':
            return { type: 'pageBottomMenuSheetControl', pageId: parentInfo.context.pageId };
        case 'isPageTopNavBar':
            return { type: 'pageTopNavControl', pageId: parentInfo.context.pageId };
        default:
            throw new Error('Error invalid context type');
    }
};
exports.default = calculateControlContextFromParentInfo;
